import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { BellOff, CheckCircle2 } from "lucide-react";
import { api, extractError } from "../lib/api";
import { Logo } from "../components/Logo";

export default function WaitlistCancelPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [done, setDone] = useState(false);
  const [eventTitle, setEventTitle] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [notFound, setNotFound] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      const r = await api.post("/public/waitlist/cancel", { token });
      setEventTitle(r.data.event_title || "");
      setDone(true);
      setError("");
    } catch (e) {
      setError(extractError(e));
      if (e?.response?.status === 404) setNotFound(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--gt-bg-marketing)] flex flex-col">
      <header className="px-6 sm:px-10 py-5 border-b border-[var(--gt-line)] bg-white">
        <Logo size="md" />
      </header>
      <main className="flex-1 flex items-start justify-center px-4 py-12">
        <div className="w-full max-w-lg gt-card bg-white text-center py-8" data-testid="waitlist-cancel-card">
          {done ? (
            <>
              <CheckCircle2 size={40} className="mx-auto text-emerald-600 mb-3" />
              <h1 className="font-heading text-2xl font-black tracking-tight" data-testid="waitlist-cancel-done">
                You've left the waitlist
              </h1>
              <p className="mt-3 text-sm text-[var(--gt-ink-2)] max-w-sm mx-auto">
                You won't receive availability alerts{eventTitle ? <> for <strong>{eventTitle}</strong></> : null} anymore.
              </p>
              <Link to="/events" className="inline-block mt-6 text-sm underline underline-offset-2">
                Browse other events
              </Link>
            </>
          ) : (
            <>
              <BellOff size={40} className="mx-auto text-[var(--gt-ink-2)] mb-3" />
              <h1 className="font-heading text-2xl font-black tracking-tight">Leave the waitlist?</h1>
              <p className="mt-3 text-sm text-[var(--gt-ink-2)] max-w-sm mx-auto">
                You'll stop receiving ticket-availability alerts for this event.
              </p>
              {error && <div className="mt-3 text-xs text-red-600" data-testid="waitlist-cancel-error">{error}</div>}
              <button
                type="button"
                onClick={confirm}
                disabled={busy || !token || notFound}
                className="gt-btn-primary mt-6 disabled:opacity-40"
                data-testid="waitlist-cancel-confirm-btn"
              >
                {busy ? "Working…" : "Yes, remove me"}
              </button>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
